export default __webpack_public_path__ + "static/media/excel.33a49c84.svg";